import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { registrationsViewAPI } from "../../../api/apiClient";
import Loading from "../../../Loading";
import "../../../css/Views/RegistrationsView.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const RegistrationsView = () => {
  const { callApi, isLoading, error } = useApi();
  const [registrations, setRegistrations] = useState([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 10;
  const navigate = useNavigate();

  const fetchData = () => {
    callApi(() => registrationsViewAPI.getRegistrations({ page, pageSize }), (data) => {
      setRegistrations(data.items);
      setTotalCount(data.totalCount);
    });
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const maxPage = Math.ceil(totalCount / pageSize);

  return (
    <div className="registrations-view">
      <div className="bank-header">
        Lista rezerwacji
        <FontAwesomeIcon icon={faSyncAlt} className="refresh-icon" onClick={fetchData} />
      </div>

      {isLoading && <Loading text="Ładowanie rezerwacji..." />}
      {error && <p className="error">Błąd: {error.message}</p>}

      {!isLoading && registrations.length === 0 && <p>Brak rezerwacji do wyświetlenia.</p>}

      {!isLoading && (
        <>
          <div className="registration-view-list">
            {registrations.map((r) => (
            <div
              key={r.guid}
              className="registration-view-line clickable"
              onClick={() => navigate(r.navigateTo)}
            >
              <div className="registration-view-top-line">
                <span className={`reg-code status-${r.reservationStatus}`}>
                  {r.reservationCode}
                </span>
                <span className="reservation-view-time">
                  {new Date(r.reservationTime).toLocaleString("pl-PL")}
                </span>
              </div>
              <div className="registration-view-bottom-line">
                <strong>{r.mainParticipantName || r.createdByMail}</strong> – {r.tripName}
              </div>
            </div>

            ))}
          </div>

          <div className="pagination-controls">
            {page > 1 && (
              <div onClick={() => setPage((p) => p - 1)}>
                <FontAwesomeIcon icon={faArrowLeft} /> Poprzednia
              </div>
            )}
            <span>
              Strona {page} z {maxPage}
            </span>
            {page < maxPage && (
              <div onClick={() => setPage((p) => p + 1)}>
                Następna <FontAwesomeIcon icon={faArrowRight} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default RegistrationsView;
